import { Box, styled, Typography } from '@mui/material';
import Option from './Option';

const Container = styled(Box)(() => ({
  padding: 16,
  gap: 16,
  paddingTop: 28,
  flex: 1,
  display: 'flex',
  alignSelf: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'relative',
  maxWidth: 600,

  '@supports (width: -webkit-fill-available)': {
    width: '-webkit-fill-available',
  },

  '@supports (width: -moz-available)': {
    width: '-moz-available',
  },
}));

const Image = styled('img')(() => ({
  width: 144,
  height: 144,
  bottom: 0,
  right: 0,
  alignSelf: 'flex-end',
  justifySelf: 'flex-end',
  position: 'absolute',
}));

type OptionType = {
  question: string;
  answer: string;
};

type Props = {
  title: string;
  options: OptionType[];
  selectedAnswer: string;
  image: string;
  onSelect: (answer: string) => void;
};

export default function FrequencyForm({ title, options, selectedAnswer, image, onSelect }: Props) {
  return (
    <Container>
      <Box gap={2} display="flex" flexDirection="column">
        <Typography fontSize={28} fontWeight={700} lineHeight="32px" color="black">
          {title}
        </Typography>
        <Box gap={0.5} display="flex" flexDirection="column">
          {options.map((item, index) => {
            const active = selectedAnswer === item.answer;
            const isDisabled = Boolean(selectedAnswer);

            return (
              <Option
                key={index}
                active={active}
                disabled={isDisabled}
                name={item.answer}
                onClick={() => onSelect(item.answer)}
              />
            );
          })}
        </Box>
      </Box>
      <Image src={image} />
    </Container>
  );
}
